export function responsevideoValid(rv){
  return rv && rv.has_data;
}